var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSocialDiscourse = function SvgSocialDiscourse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.101 0C18.664 0 24 5.484 24 11.996c0 6.511-5.328 11.992-11.899 11.992L0 24V11.79C0 5.282 5.531 0 12.101 0m.118 4.562a7.39 7.39 0 0 0-6.336 3.57 7.24 7.24 0 0 0-.149 7.219L4.4 19.608l4.797-1.074a7.42 7.42 0 0 0 8.133-1.39 7.25 7.25 0 0 0 1.738-7.996 7.38 7.38 0 0 0-6.84-4.586z"
  })));
};
export default SvgSocialDiscourse;